export default __webpack_public_path__ + "static/media/landing_gif.eb85b0df.gif";